if (document.getElementById("form_catraca_view")) {
  const start_value_1 = document.querySelector("#start_value_1");
  const end_value_1 = document.querySelector("#end_value_1");
  const start_value_2 = document.querySelector("#start_value_2");
  const end_value_2 = document.querySelector("#end_value_2");
  const error_end = document.querySelector("#error_end");
  const total = document.querySelector("#total");
  const initialTotal = document.querySelector("#total").value;
  var total_1 = 0;
  var total_2 = 0;

  end_value_1.addEventListener("change", (e) => {
    error_end.classList.add("d-none");
    error_end.classList.remove("d-block");
    var aux = parseInt(end_value_1.value);
    if (aux < parseInt(start_value_1.value)) {
      error_end.innerHTML =
        "O valor final deve ser maior ou igual que o inicial";
      error_end.classList.remove("d-none");
      error_end.classList.add("d-block");
    } else {
      total_1 = parseInt(end_value_1.value) - parseInt(start_value_1.value);
      // total.value = parseInt(initialTotal) + total_1 + total_2;
      total.value = total_1 + total_2;
    }
  });

  start_value_1.addEventListener("change", (e) => {
    error_end.classList.add("d-none");
    error_end.classList.remove("d-block");
    var aux = parseInt(start_value_1.value);
    if (aux < parseInt(end_value_1.value)) {
      error_end.innerHTML = "O valor inicial deve ser menor que o final";
      error_end.classList.remove("d-none");
      error_end.classList.add("d-block");
    } else {
      total_1 = parseInt(end_value_1.value) - parseInt(start_value_1.value);
      // total.value = parseInt(initialTotal) + total_1 + total_2;
      total.value = total_1 + total_2;
    }
  });

  end_value_2.addEventListener("change", (e) => {
    error_end.classList.add("d-none");
    error_end.classList.remove("d-block");
    var aux = parseInt(end_value_2.value);
    if (aux < parseInt(start_value_2.value)) {
      error_end.innerHTML =
        "O valor final deve ser maior ou igual que o inicial";
      error_end.classList.remove("d-none");
      error_end.classList.add("d-block");
    } else {
      total_2 = parseInt(end_value_2.value) - parseInt(start_value_2.value);
      // total.value = parseInt(initialTotal) + total_1 + total_2;
      total.value = total_1 + total_2;
    }
  });

  start_value_2.addEventListener("change", (e) => {
    error_end.classList.add("d-none");
    error_end.classList.remove("d-block");
    var aux = parseInt(start_value_2.value);
    if (aux < parseInt(end_value_2.value)) {
      error_end.innerHTML = "O valor inicial deve ser menor que o final";
      error_end.classList.remove("d-none");
      error_end.classList.add("d-block");
    } else {
      total_2 = parseInt(end_value_2.value) - parseInt(start_value_2.value);
      // total.value = parseInt(initialTotal) + total_1 + total_2;
      total.value = total_1 + total_2;
    }
  });
}

if (document.getElementById("edit_catraca_view")) {
  require("./edit");
}
